<template>
  <div v-show="GeneralInstance.isLoading" class="fixed inset-0 z-999999 flex items-center justify-center">
    <!-- overlay -->
    <div class="absolute inset-0 bg-black/70" />

    <!-- spinner -->
    <div class="relative">
      <div class="animate-spin rounded-full border-4 border-yellow-400 border-t-transparent h-36 w-36" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import GeneralModule from '@/store/modules/General';

export default defineComponent({
  name: 'Loading',
  computed: {
    GeneralInstance(): any {
      return getModule(GeneralModule, store);
    }
  }
});
</script>
